module.exports = __webpack_public_path__ + "static/media/camera.e419da47.svg";